import { createAction, createReducer } from '@reduxjs/toolkit'

export type VisibleSlots = {
  cancelled: boolean
  // subscription types
  sub_adult_competitor: boolean
  sub_adult_leisure_advanced: boolean
  sub_adult_leisure_beginner: boolean
  sub_school_13_17: boolean
  sub_school_8_12: boolean
}

export const configureVisibleSlots = createAction<VisibleSlots>(
  'arb-website/planning/filter',
)

export default createReducer<VisibleSlots>(
  {
    cancelled: true,
    sub_adult_competitor: true,
    sub_adult_leisure_advanced: true,
    sub_adult_leisure_beginner: true,
    sub_school_13_17: true,
    sub_school_8_12: true,
  },
  (builder) => {
    builder.addCase(configureVisibleSlots, (state, { payload }) => payload)
  },
)
